module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), (_vm.auth.user == null) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear-class": "fade"
    }
  }, [(_vm.auth.user == null) ? _c('router-view', {
    attrs: {
      "name": "entry"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user !== null) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear-class": "fade"
    }
  }, [(_vm.auth.user !== null) ? _c('router-view') : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2200c7d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 340
// module chunks = 2